import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Copy = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.02545 4.41091V3.4717C5.02545 2.6589 5.68435 2 6.49715 2H12.5053C13.3181 2 13.977 2.6589 13.977 3.4717V10.1758C13.977 10.9886 13.3181 11.6475 12.5053 11.6475H10.8432V12.5283C10.8432 13.3411 10.1843 14 9.37149 14H3.49471C2.68191 14 2.02301 13.3411 2.02301 12.5283V5.88261C2.02301 5.06982 2.68191 4.41091 3.49471 4.41091H5.02545ZM6.15752 3.4717C6.15752 3.28413 6.30958 3.13208 6.49715 3.13208H12.5053C12.6929 3.13208 12.8449 3.28413 12.8449 3.4717V10.1758C12.8449 10.3634 12.6929 10.5155 12.5053 10.5155H10.8432V5.88261C10.8432 5.06981 10.1843 4.41091 9.37149 4.41091H6.15752V3.4717ZM3.15509 5.88261C3.15509 5.69505 3.30714 5.54299 3.49471 5.54299H9.37149C9.55906 5.54299 9.71112 5.69504 9.71112 5.88261V12.5283C9.71112 12.7159 9.55906 12.8679 9.37149 12.8679H3.49471C3.30714 12.8679 3.15509 12.7159 3.15509 12.5283V5.88261Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Copy;
